import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import './assets/scss/app.scss'
import router from './router'
import VueParticles from 'vue-particles'
import TitleMixin from '@/mixins/title_mixin.js'

Vue.use(Buefy)
Vue.use(VueParticles)

Vue.mixin(TitleMixin)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')